import { Link } from "react-router-dom";
import { Layout } from "antd";

const { Footer } = Layout;

const SiteFooter = () => {
  return (
    <Footer className="!bg-[#44795D] text-white text-center px-5 py-10">
      <div className="flex flex-wrap justify-between items-center sm:flex-nowrap">
        {/* Logo Section */}
        <div className="w-full text-center mb-5 sm:w-auto sm:text-left sm:mb-0">
          <h2 className="text-white text-2xl font-bold">Gentle-Gourmet</h2>
        </div>

        {/* Links Section */}
        <div className="flex flex-wrap justify-between items-start w-full sm:w-1/2">
          <div className="flex flex-col mx-5 flex-grow flex-shrink-0">
            <h3 className="text-white text-base font-semibold mb-2">Links</h3>
            <Link
              reloadDocument
              to="/pages/contact"
              className="mb-2 text-white text-sm hover:text-blue-300 transition-colors"
            >
              Contact
            </Link>
            <Link
              reloadDocument
              to="/pages/our-vision"
              className="mb-2 text-white text-sm hover:text-blue-300 transition-colors"
            >
              Our Vision
            </Link>
            <Link
              to="https://patreon.com/GentleGourmetRecipes?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink"
              className="mb-2 text-white text-sm hover:text-blue-300 transition-colors"
            >
              Patreon
            </Link>
          </div>

          <div className="flex flex-col mx-5 flex-grow flex-shrink-0">
            <h3 className="text-white text-base font-semibold mb-2">Legal</h3>
            <Link
              reloadDocument
              to="/pages/privacy-policy"
              className="mb-2 text-white text-sm hover:text-blue-300 transition-colors"
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>

      {/* Social Media Icons */}
      <div className="flex justify-center space-x-6 mt-6 mb-4">
        <a
          href="https://instagram.com/gentle.gourmet"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-pink-400 transition-colors"
          aria-label="Follow us on Instagram"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </a>

        <a
          href="https://pinterest.com/gentlegourmetrecipes"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-red-400 transition-colors"
          aria-label="Follow us on Pinterest"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.219-.359-1.219c0-1.142.662-1.997 1.482-1.997.699 0 1.037.219 1.037 1.142 0 .695-.442 1.736-.219 2.701.199.847.883 1.524 1.822 1.524 2.188 0 3.668-2.311 3.668-5.653 0-2.947-2.118-5.013-5.127-5.013-3.49 0-5.546 2.619-5.546 5.332 0 1.058.402 2.188.906 2.804.099.12.114.225.084.348-.092.383-.301 1.219-.342 1.391-.054.219-.179.265-.413.159-1.546-.72-2.512-2.967-2.512-4.773 0-3.883 2.822-7.447 8.119-7.447 4.247 0 7.554 3.027 7.554 7.065 0 4.212-2.657 7.597-6.342 7.597-1.237 0-2.403-.644-2.801-1.406 0 0-.614 2.342-.765 2.917-.277 1.075-1.024 2.424-1.526 3.247C9.539 23.812 10.749 24.029 12.017 24.029c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z" />
          </svg>
        </a>
      </div>

      {/* Copyright */}
      <div className="mt-5 sm:mt-0">
        <p className="text-white text-sm">
          © 2023 Gentle-Gourmet. All Rights Reserved.
        </p>
      </div>
    </Footer>
  );
};

export default SiteFooter;
